import { ILGEChange } from "../interfaces/ILGEChange";
import { ILGEStatic } from "../interfaces/ILGEStatic";
import { LGCouncil } from "./LGCouncil";


export class LGE {
    private readonly _lgeChange: ILGEChange | null;
    private readonly _lgeStatic: ILGEStatic;
    private readonly _nominationClose: Date | null;

    public councils: LGCouncil[] = [];
    constructor(
        lgeChange: ILGEChange | null,
        lgeStatic: ILGEStatic,
        nominationClose: Date | null
    ) {
        this._lgeChange = lgeChange;
        this._lgeStatic = lgeStatic;
        this._nominationClose = nominationClose;

        this._lgeStatic.councils.forEach(council => {
            const foundLGEChangeCouncil = this._lgeChange?.councils.find(lgeChangeCouncil => lgeChangeCouncil.uid === council.uid);
            this.councils.push(new LGCouncil(foundLGEChangeCouncil ? foundLGEChangeCouncil : null, council, this._nominationClose));
        });
    }

    get uid(): string {
        return this._lgeStatic.uid;
    }

    get electionDate(): Date {
        return this._lgeStatic.electionDate;
    }

    get electionName(): string {
        return this._lgeStatic.electionName;
    }   

    get electionStatus(): string {
        return this._lgeStatic.electionStatus;
    }

    get dataVersion(): number {
        return this._lgeStatic.dataVersion;
    }



}